var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 150,
    viewBox: "0 0 226 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.6969 34.083V103.705L25.6553 111.816V34.083H33.6969Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.3341 14.9336V81.3902C44.5227 84.0226 43.4618 87.2084 43.4618 90.6399C43.4618 91.6317 43.5516 92.6176 43.7281 93.5873L38.2925 99.0686V14.9336H46.3341Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M58.9708 1.14941V74.2939C56.0161 74.4469 53.2674 75.3886 50.9292 76.9116V1.14941H58.9708Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.6085 19.9141V79.2825C69.4587 77.0517 66.682 75.4301 63.5669 74.7003V19.9141H71.6085Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M84.2467 12.6367V102.199L76.2036 94.1569V12.6367H84.2467Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M96.8839 32.5508V111.516C95.9422 111.619 95.0196 111.803 94.1146 112.068L88.8408 106.794V32.5508H96.8825H96.8839Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M109.521 18.9561V104L102.561 111.874C102.203 111.787 101.843 111.714 101.479 111.654V18.9561H109.521Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M122.158 1.14941V89.7032L114.115 98.8029V1.14941H122.158Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M134.795 17.8066V64.6336C133.1 67.2102 132.114 70.2915 132.114 73.6008C132.114 75.0385 132.298 76.4496 132.663 77.8196L126.752 84.506V17.8066H134.794H134.795Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M147.432 4.97754V57.2637C144.47 57.4521 141.72 58.4321 139.391 59.9948V4.97754H147.432Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M160.069 23.9336V62.0435C157.902 59.8701 155.13 58.3015 152.028 57.6173V23.9351H160.069V23.9336Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M172.706 43.2725V80.7158C171.647 80.8438 170.602 81.0793 169.591 81.4103L164.665 76.6295V43.2725H172.706Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M185.343 5.16895V72.3362L178.117 80.9429C177.848 80.8856 177.575 80.8355 177.302 80.7914V5.16895H185.343Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M197.981 45.4909C197.36 47.214 197.023 49.071 197.023 51.0075C197.023 52.9439 197.348 54.7627 197.981 56.5226V57.2848L189.939 66.8642V0H197.981V45.4909Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M164.856 73.6002C164.856 74.4404 164.793 75.2732 164.665 76.0973V71.0986C164.791 71.9138 164.856 72.7511 164.856 73.6016V73.6002Z",
    fill: "#C8CAC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M213.394 38.4658C206.468 38.4658 200.853 44.081 200.853 51.0073C200.853 53.4234 201.537 55.6778 202.72 57.5922L179.428 85.3384C177.973 84.7484 176.384 84.4202 174.716 84.4202C172.555 84.4202 170.521 84.9676 168.747 85.93L160.321 77.75C160.776 76.4507 161.027 75.0557 161.027 73.6019C161.027 66.6756 155.412 61.0604 148.486 61.0604C141.56 61.0604 135.944 66.6756 135.944 73.6019C135.944 75.4089 136.33 77.1261 137.017 78.677L103.753 116.309C102.208 115.627 100.499 115.246 98.7026 115.246C96.7147 115.246 94.8356 115.711 93.1654 116.534L71.6068 94.9752C72.1041 93.6243 72.3763 92.1661 72.3763 90.6431C72.3763 83.7169 66.7612 78.1017 59.8349 78.1017C52.9086 78.1017 47.2934 83.7169 47.2934 90.6431C47.2934 92.0793 47.5377 93.4566 47.9821 94.7427L17.1766 125.806C15.7419 125.235 14.1792 124.917 12.5414 124.917C5.61518 124.917 0 130.532 0 137.458C0 144.385 5.61518 150 12.5414 150C19.4677 150 25.0829 144.385 25.0829 137.458C25.0829 135.685 24.7135 134 24.0499 132.471L54.3463 101.922C56.0046 102.73 57.866 103.185 59.8349 103.185C61.8037 103.185 63.5077 102.765 65.1131 102.021L86.8336 123.741C86.401 125.011 86.1627 126.372 86.1627 127.789C86.1627 134.715 91.7778 140.331 98.7041 140.331C105.63 140.331 111.246 134.715 111.246 127.789C111.246 126.188 110.942 124.659 110.395 123.251L143.948 85.2943C145.356 85.8417 146.885 86.1448 148.486 86.1448C150.44 86.1448 152.291 85.6975 153.941 84.8999L162.694 93.3977C162.359 94.5278 162.176 95.7241 162.176 96.9631C162.176 103.889 167.792 109.505 174.718 109.505C181.644 109.505 187.259 103.889 187.259 96.9631C187.259 95.2312 186.908 93.5802 186.273 92.0793L210.506 63.2132C211.434 63.4325 212.401 63.5517 213.396 63.5517C220.322 63.5517 225.937 57.9365 225.937 51.0102C225.937 44.0839 220.322 38.4688 213.396 38.4688L213.394 38.4658Z",
    fill: "#B2B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataDashboard);
export default __webpack_public_path__ + "static/media/noDataDashboard.15acfb81919f3e8f809100bb8182787d.svg";
export { ForwardRef as ReactComponent };